module.exports = "/static/frontend-4.0/static/img/landevej.mp4";